import React from 'react'
import { Section, Container, Columns, Column } from 'sqrl-design-system'

export default ({ top, left, right, bottom, swapOnMobile }) => (
  <Section className="hero-section">
    <Container>
      {top}
      <Columns className={swapOnMobile ? 'reverse-on-mobile' : null}>
        <Column>{left}</Column>
        <Column>{right}</Column>
      </Columns>
      {bottom}
    </Container>
  </Section>
)
